import ListPros from './ListPros.container';
import { DEFAULT_PAGE, NUM_PROS_PER_PAGE } from './ListPros';

export { DEFAULT_PAGE, NUM_PROS_PER_PAGE };
export type { ListProsProps } from './ListPros';
export default ListPros;
